import { Fragment } from "react"
import PropTypes from "prop-types"
import { Link } from "@reach/router"
import { Menu, MenuButton, MenuList, MenuItem, MenuLink } from "@reach/menu-button"
import Icon from "components/planning_center_icon"
import Checkbox from "components/ui/Checkbox"

const DropdownMenu = ({ text, icon, items = [], className = "btn2" }) => {
  const renderMenuItem = item => {
    if (item.render) {
      return item.render(item)
    }

    return item.onClick ? renderItem(item) : renderLink(item)
  }

  const renderItem = item => {
    const { key, render, text, onClick, isSelected, ...rest } = item

    return render ? (
      render()
    ) : (
      <MenuItem onSelect={() => onClick(item)} {...rest} className="dropdown-menu-item">
        {isSelected !== undefined ? (
          <Checkbox text={text} checked={isSelected} value={text} htmlFor={key} />
        ) : (
          text
        )}
      </MenuItem>
    )
  }

  const renderLink = item => {
    const { render, text, href, linkTo, isExternal, ...rest } = item

    const linkProps = {
      ...(href && { as: "a", href: href }),
      ...(linkTo && { as: Link, to: linkTo }),
      ...(isExternal && { target: "_blank", rel: "noopener noreferrer" })
    }

    return (
      <MenuLink {...rest} {...linkProps}>
        {text}
      </MenuLink>
    )
  }

  return (
    <Menu>
      <MenuButton className={className}>
        {icon && <Icon symbol={icon} />}
        {text}
        <span data-reach-menu-button-toggle-icon style={{ margin: "0 0 0 4px" }}>
          <Icon symbol="general#down-caret" style={{ margin: 0 }} />
        </span>
      </MenuButton>
      <MenuList>
        {items.map(item => (
          <Fragment key={item.key || item.text}>{renderMenuItem(item)}</Fragment>
        ))}
      </MenuList>
    </Menu>
  )
}

DropdownMenu.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
      linkTo: PropTypes.string,
      href: PropTypes.string
    })
  )
}

export default DropdownMenu
